(() => {
  const items = document.querySelectorAll('[data-reveal]');
  items.forEach((item) => item.classList.add('visible'));

  const menuBtn = document.querySelector('[data-menu-btn]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (menuBtn && menu) {
    menuBtn.addEventListener('click', () => {
      const open = menuBtn.getAttribute('aria-expanded') === 'true';
      menuBtn.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  }

  document.querySelectorAll('[data-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const mainImage = document.querySelector('[data-main-img]');
      if (mainImage) {
        mainImage.src = button.dataset.src;
        mainImage.alt = button.dataset.alt || '';
      }
    });
  });

  // V16.7: Amazon-style variant image switching for pack-size variants
  const updateKalyaniVariant = () => {
    const checked = document.querySelector('[data-variant-radio]:checked') || document.querySelector('[data-variant-radio]');
    if (!checked) return;

    const buy = document.querySelector('[data-buy-now]');
    const qty = document.querySelector('[data-qty]');
    const mainImage = document.querySelector('[data-main-img]');
    const price = document.querySelector('[data-variant-price]');
    const mrp = document.querySelector('[data-variant-mrp]');
    const save = document.querySelector('[data-variant-save]');
    const atc = document.querySelector('.kv-atc');

    const quantity = qty ? Math.max(1, parseInt(qty.value || '1', 10)) : 1;
    if (buy) buy.href = `/cart/${checked.value}:${quantity}?checkout`;

    if (price && checked.dataset.price) price.textContent = checked.dataset.price;

    if (mrp) {
      if (checked.dataset.mrp) {
        mrp.hidden = false;
        mrp.innerHTML = `MRP: <s>${checked.dataset.mrp}</s>`;
      } else {
        mrp.hidden = true;
      }
    }

    if (save) save.textContent = checked.dataset.mrp ? 'Offer price' : 'Premium ritual essential';

    if (atc) {
      const isAvailable = checked.dataset.available !== 'false' && !checked.disabled;
      atc.disabled = !isAvailable;
      atc.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
    }

    if (mainImage && checked.dataset.image) {
      mainImage.src = checked.dataset.image;
      mainImage.alt = checked.dataset.imageAlt || checked.dataset.variantTitle || '';
      mainImage.classList.add('kv-image-swap');
      setTimeout(() => mainImage.classList.remove('kv-image-swap'), 320);
    }
  };

  document.querySelectorAll('[data-variant-radio]').forEach((input) => {
    input.addEventListener('change', updateKalyaniVariant);
  });
  document.querySelectorAll('[data-qty]').forEach((qty) => {
    qty.addEventListener('input', updateKalyaniVariant);
  });
  updateKalyaniVariant();

})();